import React from 'react';

interface AuditLogSvgIconProps {
  size?: number;
  color?: string;
}

/**
 * Custom Audit Log icon: clipboard with document lines + magnifying glass containing a checkmark.
 * Matches the exact design from the reference image.
 */
const AuditLogSvgIcon: React.FC<AuditLogSvgIconProps> = ({
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth="5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Clipboard body */}
    <rect x="12" y="18" width="60" height="74" rx="4" ry="4" />

    {/* Clipboard clip (top center) */}
    <rect x="32" y="10" width="20" height="14" rx="5" ry="5" />
    {/* Clip inner hole */}
    <rect x="37" y="13" width="10" height="8" rx="3" ry="3" fill="white" stroke={color} strokeWidth="2.5" />

    {/* Document lines */}
    <line x1="24" y1="36" x2="60" y2="36" />
    <line x1="24" y1="46" x2="60" y2="46" />
    <line x1="24" y1="56" x2="55" y2="56" />
    <line x1="24" y1="66" x2="50" y2="66" />
    <line x1="24" y1="76" x2="45" y2="76" />

    {/* Magnifying glass circle */}
    <circle cx="68" cy="72" r="18" />

    {/* Magnifying glass handle */}
    <line x1="81" y1="85" x2="90" y2="94" strokeWidth="6" />
  </svg>
);

export default AuditLogSvgIcon;
